import { render, staticRenderFns } from "./SalesClientsActivityChart.vue?vue&type=template&id=bb311586&scoped=true"
import script from "./SalesClientsActivityChart.vue?vue&type=script&lang=js"
export * from "./SalesClientsActivityChart.vue?vue&type=script&lang=js"
import style0 from "./SalesClientsActivityChart.vue?vue&type=style&index=0&id=bb311586&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb311586",
  null
  
)

export default component.exports